<a class="skip-to-content" href="#main-content">Skip to main content</a>
@let isAuthenticated = isAuthenticated$ | async;
@let isAiChatOpen = isAiChatOpen$ | async;
@if (isAuthenticated) {
  <valumize-header></valumize-header>
}
<main id="main-content" [class.ai-chat-open]="isAiChatOpen">
  <router-outlet></router-outlet>
</main>
@if (isAuthenticated) {
  @if (isAiChatOpen) {
    <aside class="ai-chat-side-panel" role="complementary" aria-label="AI Chat Assistant">
      <valumize-ai-chat-panel></valumize-ai-chat-panel>
    </aside>
  }
  @if (!isAiChatOpen) {
  <button mat-fab
    aria-label="Open Valumize AI Chat"
    data-test="valumize-ai-chat-button"
        style="position: fixed;
               bottom: 20px;
               right: 20px;
               z-index: 1001;
               width: 55px;
               height: 55px;
               background-color: var(--color-primary);"
    (click)="toggleAiChat()">
    <img alt="Valumize AI Chat" style="height: 40px; width: 40px" data-test="ai-chat-logo" src="assets/logo.svg"/>
  </button>
  }
}
